import { render, staticRenderFns } from "./PosterTextIndex.vue?vue&type=template&id=612f4677&scoped=true&"
import script from "./PosterTextIndex.vue?vue&type=script&lang=js&"
export * from "./PosterTextIndex.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextIndex.vue?vue&type=style&index=0&id=612f4677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f4677",
  null
  
)

export default component.exports